(() => {
  // Helps when Safari or theme scripts fight scroll restoration
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";

  const LIST_PAGE_TEMPLATES = new Set(["collection", "search", "index"]);

  const getTemplate = () => {
    const cls = Array.from(document.body.classList).find((c) => c.startsWith("template-"));
    return cls ? cls.replace("template-", "") : "";
  };

  const isListPage = () => LIST_PAGE_TEMPLATES.has(getTemplate());

  const storageKey = () => `scrollpos:${location.pathname}${location.search}`;

  const saveScroll = () => {
    if (!isListPage()) return;
    try {
      sessionStorage.setItem(storageKey(), String(window.scrollY || 0));
      sessionStorage.setItem("scrollpos:last_list_url", location.pathname + location.search);
    } catch (e) {}
  };

  const restoreScroll = () => {
    if (!isListPage()) return;

    let y = null;
    try {
      y = sessionStorage.getItem(storageKey());
      if (y === null) {
        const last = sessionStorage.getItem("scrollpos:last_list_url");
        if (last) y = sessionStorage.getItem(`scrollpos:${last}`);
      }
    } catch (e) {}

    if (y === null) return;

    const target = parseInt(y, 10);
    if (Number.isNaN(target)) return;

    // Flag so we can optionally tell Dawn scripts to not scroll-to-top during restore
    window.__bzScrollRestoring = true;

    // Mobile Safari often needs multiple passes due to late layout changes
    const attempts = [0, 50, 150, 300, 600, 1000];

    attempts.forEach((ms) => {
      setTimeout(() => {
        window.scrollTo(0, target);
      }, ms);
    });

    // Release the flag after the dust settles
    setTimeout(() => {
      window.__bzScrollRestoring = false;
    }, 1200);
  };

  // Save aggressively, especially for iOS taps and swipe-back behavior
  window.addEventListener("pagehide", saveScroll);
  window.addEventListener("beforeunload", saveScroll);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") saveScroll();
  });

  // Save before navigation on taps/clicks
  const saveOnNavIntent = (e) => {
    const a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!a) return;
    if (a.origin !== location.origin) return;
    if (!isListPage()) return;
    saveScroll();
  };

  document.addEventListener("pointerdown", saveOnNavIntent, true);
  document.addEventListener("touchstart", saveOnNavIntent, true);
  document.addEventListener("click", saveOnNavIntent, true);

  // Restore on return (works for BFCache and normal reloads)
  window.addEventListener("pageshow", restoreScroll);
  window.addEventListener("popstate", () => setTimeout(restoreScroll, 0));
})();
